export default function SVG_Rectangle() {
  return (
    <div>
      <h1>SVG_Rectangle Component</h1>
    </div>
  );
}
